var swiper = new Swiper(".aboutSwiper", {
  slidesPerView: 'auto',
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on:{
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        this.params.slidesPerView = 'auto'
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.slidesPerView = '1'
      } else {
        this.disable();
      }
    }
  }
});


var module4ThumbsSwiper = new Swiper(".module4ThumbsSwiper", {
  spaceBetween: 0,
  slidesPerView: 2,
  freeMode: true,
  watchSlidesProgress: true,
});
var module4Swiper = new Swiper(".module4Swiper", {
  spaceBetween: 0,
  autoHeight: true,
  thumbs: {
    swiper: module4ThumbsSwiper,
  },
});

$('.module4-nav-button').on('click', function() {
  var model = $(this).data('model');
  $('.module4-nav-button').removeClass('tw-border-black').addClass('tw-border-[#EAEAEA]');
  $('.module4-nav-button').removeClass('tw-text-black').addClass('tw-text-[#8F8F8F]');
  $(this).removeClass('tw-border-[#EAEAEA]').addClass('tw-border-black');
  $(this).removeClass('tw-text-[#8F8F8F]').addClass('tw-text-black');

  $('.module4-item').each(function() {
    if ($(this).data('model') === model) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
});